import {
    UpdateAgentId,
} from './model';

import {
    Action,
} from 'one-state';

import {
    SET,
    REINIT
} from './types';

/**
 * Redux action creator to initate Screenpop
 * @param userdata object with values
 * @returns action instance
 */
export const setAction = (userdata: UpdateAgentId):
    Action<typeof SET, UpdateAgentId> => ({
        type: SET,
        payload: userdata,
    });

/**
 * Re-initialize the state
 * @returns action instance
 */
export const reinitAction = ():
    Action<typeof REINIT> => ({
        type: REINIT,
    });

/**
 * List of all valid actions
 */
export type Actions =
    ReturnType<typeof setAction> |
    ReturnType<typeof reinitAction>
